import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';

const Signin = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = (values) => {
    setLoading(true);
    const { username, password } = values;
    const users = JSON.parse(localStorage.getItem('users')) || [];
    const user = users.find(user => user.username === username);

    if (user) {
      if (user.password === password) {
        message.success('Login successful!');
        localStorage.setItem('currentUser', JSON.stringify(user));
        navigate('/game');
      } else {
        message.error('Incorrect password!');
      }
    } else {
      const newUser = { 
        username, 
        password,
        win: 0,
        lose: 0,
        draw: 0,
        score: 0,
        streak: 0,
        totalgame:0
      };
      users.push(newUser);
      localStorage.setItem('users', JSON.stringify(users));
      localStorage.setItem('currentUser', JSON.stringify(newUser));
      message.success('User created and login successful!');
      navigate('/game');
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 300, margin: 'auto', paddingTop: 100 }}>
      <Form
        name="signin"
        onFinish={onFinish}
        initialValues={{ remember: true }}
        style={{backgroundColor:"#5F374B", padding: "5%", borderRadius:"5%"}}
      >
        <p style={{textAlign:'center',color:'white',fontSize:28,fontWeight:'bold'}}>Tic Tac Toe</p>
        <Form.Item
          name="username"
          rules={[
            { required: true, message: 'Please input your username!' },
            { min: 5, message: 'Username must be at least 5 characters long!' },
            { max: 10, message: 'Username must be at most 10 characters long!' }
          ]}
        >
          <Input placeholder="Username" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[
            { required: true, message: 'Please input your password!' },
            { min: 4, message: 'Password must be at least 4 characters long!' },
            { max: 8, message: 'Password must be at most 8 characters long!' }
          ]}
        >
          <Input.Password placeholder="Password" />
        </Form.Item>

        <Form.Item>
          <Button style={{backgroundColor:'transparent',borderWidth:2,color:'white',fontWeight:'600'}} htmlType="submit" loading={loading}>
            Sign In
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Signin;
